export const UPDATE_RADIO_SELECTION          = 'UPDATE_RADIO_SELECTION';
export const UPDATE_CHECKBOX_SELECTION       = 'UPDATE_CHECKBOX_SELECTION';
export const UPDATE_TEXTFIELD                = 'UPDATE_TEXTFIELD';
export const SALVA_DATI_QUESTIONARIO         = 'SALVA_DATI_QUESTIONARIO';
export const SALVA_ESITO_DATI_QUESTIONARIO   = 'SALVA_ESITO_DATI_QUESTIONARIO';
export const UPDATE_DATI_QUESTIONARIO_VALIDA = 'UPDATE_DATI_QUESTIONARIO_VALIDA';
export const UPDATE_CHANGED_FROM_SEMPLIFICATO= 'UPDATE_CHANGED_FROM_SEMPLIFICATO';
export const UPDATE_TIPO_CURRENT_QUESTIONARIO= 'UPDATE_TIPO_CURRENT_QUESTIONARIO';
//export const UPDATE_SHOW_SEMPLIFICATO        = 'UPDATE_SHOW_SEMPLIFICATO';